import * as Yup from "yup";

import {
  checkTruthyValue,
  INVALID_RESPONSE_MSG,
  nullableNumberValidation,
  VALIDATION_DATE,
} from "utils/validation";

const validation = Yup.object({
  purposeOfLoan: Yup.string().required(INVALID_RESPONSE_MSG),

  loanTermMonths: Yup.number()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG)
    .min(1, "Loan term must be at least 1 month"),

  firstChargeMortgageValue: Yup.string().required(INVALID_RESPONSE_MSG),

  loanAmount: Yup.string().required(INVALID_RESPONSE_MSG),

  propertyPurchasePrice: Yup.string().required(INVALID_RESPONSE_MSG),

  estimatedPropertyValue: Yup.string().required(INVALID_RESPONSE_MSG),

  firstChargeLender: Yup.string().required(INVALID_RESPONSE_MSG),

  remainingTermOfFirstChargeLoanYears: Yup.string().when(
    "remainingTermOfFirstChargeLoanMonths",
    {
      // Remaining term can be empty or validated in range if values given
      is: (value: any) =>
        (value && value !== undefined && value !== null && value !== "") ||
        value === 0 ||
        value === "0",
      then: () =>
        Yup.number()
          .typeError(INVALID_RESPONSE_MSG)
          .required(INVALID_RESPONSE_MSG)
          .min(0, VALIDATION_DATE)
          .test(
            "total-duration-min",
            "Total term must be at least 1 year",
            function (value) {
              const months =
                this.parent.remainingTermOfFirstChargeLoanMonths || 0;
              const totalMonths = (value || 0) * 12 + months;
              return totalMonths >= 12; // 1 year in months
            },
          )
          .test(
            "total-duration-max",
            "Total term can not be more than 40 years",
            function (value) {
              const months =
                this.parent.remainingTermOfFirstChargeLoanMonths || 0;
              const totalMonths = (value || 0) * 12 + months;
              return totalMonths <= 480; // 40 years
            },
          ),
      otherwise: () => nullableNumberValidation,
    },
  ),

  remainingTermOfFirstChargeLoanMonths: Yup.number()
    .max(11, VALIDATION_DATE)
    .nullable()
    .transform((_, val) => (val === Number(val) ? val : null)),

  isInterestRateFixedForAnInitialPeriod: Yup.bool()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG),

  remainingTermOfInitialInterestRatePeriodMonths: Yup.string().when(
    "isInterestRateFixedForAnInitialPeriod",
    {
      is: (value: any) => checkTruthyValue(value),
      then: () =>
        Yup.number()
          .typeError(INVALID_RESPONSE_MSG)
          .required(INVALID_RESPONSE_MSG),
      otherwise: () => nullableNumberValidation,
    },
  ),
}).nullable();

export default validation;
